import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Button, TextInput } from '@demandlocal/components'
import { motion } from 'framer-motion'

export default function OnboardingStepTwo({
  onBackPress,
}: {
  onBackPress: () => void
}): JSX.Element {
  const { control } = useFormContext()

  return (
    <div className="w-full">
      {/* Header */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-800">Let's add your agency!</h2>
        <p className="mt-2 text-md text-gray-600">
          Enter your agency details below and get ready to shine!
        </p>
      </div>

      {/* Form Fields */}
      <div className="mb-10 space-y-6">
        {/* Agency Name - full width */}
        <div>
          <TextInput
            inverted
            name="agency_name"
            label="Agency Name"
            control={control}
            rules={{ required: 'Agency name is required' }}
          />
        </div>

        {/* Contact Email and Billing Email - side by side on larger screens */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <TextInput
              inverted
              name="contact_email"
              label="Contact Email"
              control={control}
              rules={{
                required: 'Contact email is required',
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'Enter a valid email address',
                },
              }}
            />
          </div>
          <div>
            <TextInput
              inverted
              name="billing_email"
              label="Billing Email"
              control={control}
              rules={{
                required: 'Billing email is required',
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'Enter a valid email address',
                },
              }}
            />
          </div>
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-between">
        <Button variant="secondary" type="button" animate={false} onClick={onBackPress}>
          Back
        </Button>
        <Button type="submit" animate={false}>
          Next: Add your dealership
        </Button>
      </div>
    </div>
  )
}
